import React from 'react';
import PropTypes from 'prop-types';
import {Button, Popup} from 'semantic-ui-react';

const ActionButton = (props) => {
    const handleClick = (event) => {
        if (props.stopPropagation) {
            event.stopPropagation();
        }

        if (props.button?.disabled) {
            return;
        }

        if (props.onClick) {
            if (undefined !== props.actionParams) {
                return props.onClick(props.actionParams);
            }

            return props.onClick();
        }
    };

    const button = <Button {...props.button} onClick={handleClick}/>;

    if (props.popup) {
        return (
            <Popup
                position='top right'
                trigger={<span>{button}</span>}
                {...props.popup}
            />
        );
    }

    return button;
};

ActionButton.propTypes = {
    actionParams: PropTypes.object,
    button: PropTypes.object,
    onClick: PropTypes.func,
    popup: PropTypes.object,
    stopPropagation: PropTypes.bool,
};

export default ActionButton;
